import { useState, useEffect, useRef } from "react";
import axios from "axios";
import Flatpickr from "react-flatpickr";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import moment from "moment";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import Alert from "../Alert";
import PermissionGate from "../layout/PermissionGate";
import RevenueChart from "./RevenueChart";

const RevenueStat = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [start, setStart] = useState(
    moment().subtract(5, "months").startOf("month").format("YYYY-MM-DD")
  );
  const [end, setEnd] = useState(moment().endOf("month").format("YYYY-MM-DD"));
  const dateRangePickerRef = useRef(null);
  const token = localStorage.getItem("token");

  const fetchData = () => {
    setIsLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}revenue/stat?start=${start}&end=${end}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          setData(res.data.data);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch(console.error);
  };
  const openCalendar = () => {
    if (dateRangePickerRef.current) {
      dateRangePickerRef.current.flatpickr.open();
    }
  };
  const reset = () => {
    const defaultStart = moment()
      .subtract(5, "months")
      .startOf("month")
      .format("YYYY-MM-DD");
    const defaultEnd = moment().endOf("month").format("YYYY-MM-DD");
    setStart(defaultStart);
    setEnd(defaultEnd);
  };

  useEffect(() => {
    fetchData();
  }, [start, end]);

  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      <Alert />
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                    Revenue Stat
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}

            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start  container-xxl "
            >
              {/*begin::Post*/}
              <div className="content flex-row-fluid" id="kt_content">
                {/*begin::Card*/}
                <PermissionGate required={`view_revenue_stat`}>
                  <div className="card">
                    {/*begin::Card header*/}
                    <div className="p-6">
                      <div className="d-flex justify-content-end gap-2">
                        {/*begin::Daterange*/}
                        <div className="d-flex position-relative">
                          <Flatpickr
                            ref={dateRangePickerRef}
                            value={[new Date(start), new Date(end)]}
                            options={{
                              mode: "range",
                              altInput: true,
                              altFormat: "M Y",
                              dateFormat: "Y-m-d",
                              plugins: [
                                new monthSelectPlugin({
                                  shorthand: true,
                                  dateFormat: "Y-m-d",
                                  altFormat: "M Y",
                                }),
                              ],
                              onClose: function (selectedDates) {
                                if (selectedDates.length === 2) {
                                  const startMonth = moment(selectedDates[0])
                                    .startOf("month")
                                    .format("YYYY-MM-DD");
                                  const endMonth = moment(selectedDates[1])
                                    .endOf("month")
                                    .format("YYYY-MM-DD");
                                  setStart(startMonth);
                                  setEnd(endMonth);
                                }
                              },
                            }}
                            onChange={([selectedStart, selectedEnd]) => {
                              if (selectedStart && selectedEnd) {
                                const startMonth = moment(selectedStart)
                                  .startOf("month")
                                  .format("YYYY-MM-DD");
                                const endMonth = moment(selectedEnd)
                                  .endOf("month")
                                  .format("YYYY-MM-DD");

                                setStart(startMonth);
                                setEnd(endMonth);
                              }
                            }}
                            className="form-control form-control-lg"
                            placeholder="Pick date"
                          />
                          <i
                            onClick={openCalendar}
                            className="bi-duotone bi-calendar fs-5 position-absolute"
                            style={{
                              top: "28%",
                              right: "5%",
                              cursor: "pointer",
                            }}
                          ></i>
                        </div>
                        {/*end::Daterange*/}
                        <div>
                          {/*begin::Button*/}
                          <button
                            onClick={reset}
                            className="btn btn-danger mx-auto"
                          >
                            Reset
                          </button>
                          {/*end::Button*/}
                        </div>
                      </div>
                    </div>
                    {/*end::Card header*/}

                    {/*begin::Card body*/}
                    <div className="card-body py-4 text-center">
                      <RevenueChart data={data} />
                    </div>
                    {/*end::Card body*/}
                  </div>
                </PermissionGate>
                {/*end::Card*/}
              </div>
              {/*end::Post*/}
            </div>
          </div>
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default RevenueStat;
